(function($) {

    $('.cookie-box .button').on('click', function () {

        if ($(this).hasClass('cookies-accept')) {
            var d = new Date();
            d.setTime(d.getTime() + (360 * 24 * 60 * 60 * 1000));
            var expires = "expires=" + d.toUTCString();
            document.cookie = "cookieAgreement=1;" + expires + ";path=/";
        }

        $('.cookie-box').addClass('hidden');
    });

})( jQuery );